<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import DocumentTable from "../../../common/DocumentTable.svelte";
    import type {IDocumentTableData} from "../../../interfaces";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import ServicesSlideOver from "../../ServicesSlideOver.svelte";
    import NauiTextarea from "../../../naui/atoms/NauiTextarea.svelte";

    export let data: Array<IDocumentTableData>;
    export let logistic: boolean = true;
    export let storage: boolean = true;
    export let programOpen = false;
    export let observations = null;

    let dispatch = createEventDispatcher();
    let numDays = 0;

    let open = false;

    export let serviceProgramming = {
        time: '08:30 AM',
        date: '',
        observations: '',
        additional: []
    };
    let eventTags = [
        {
            slug: 'confirmado',
            background: 'green',
            color: 'white',
            label: 'CONFIRMARDO'
        },
        {
            slug: 'programado',
            background: 'gold',
            color: 'white',
            label: 'PROGRAMADO'
        },
        {
            slug: 'cancelado',
            background: 'pink',
            color: 'white',
            label: 'CANCELADO'
        }
    ];
    let currentDay = {
        title: '',
        services: []
    };

    onMount(() => {
        console.log(serviceProgramming);
    });
</script>
<fieldset>
    <legend></legend>
    <div class="box-l sx-1">
        <NauiButton caption="PROGRAMAR SERVICIO" mode="stroked" iconFamily="fas" color="accent"
                    on:click={() => {open = true;}}/>
        <NauiButton caption="EDITAR COTIZACIÓN" mode="stroked" iconFamily="fas" color="primary"
                    on:click={() => {dispatch('action', {action: 'quote'})}}/>
        <NauiButton caption="GENERAR PDF" mode="stroked" iconFamily="fas" color="primary"
                    on:click={() => {dispatch('action', {action: 'pdf'});}}/>
        {#if logistic}
            <NauiButton caption="FACTURAR LOGÍSTICA"
                        mode="stroked"
                        iconFamily="fas"
                        color="primary"
                        on:click={() => {dispatch('action', {action: 'billing', storage: false});}}/>
        {/if}
        {#if storage}
            <NauiButton caption="FACTURAR BODEGAS"
                        mode="stroked"
                        iconFamily="fas"
                        color="primary"
                        on:click={() => {dispatch('action', {action: 'billing', storage: true});}}/>
        {/if}
    </div>
</fieldset>
<fieldset>
    <legend>LEGALIZACIÓN</legend>
    <div class="grid-2-1">
        <DocumentTable {data} documentoLabel="Requisito" checkbox={false} on:file on:action/>
        <div class="mx-15">
            <p>Observaciones internas del servicio</p>
            <div>
                <NauiTextarea label="" isDisabled value={observations ? observations.internal : ''}/>
            </div>
        </div>
    </div>
</fieldset>

<ServicesSlideOver bind:open
                   bind:currentDay
                   calendarType="Servicio"
                   idService="1"
                   program={true}
                   backButton={false}
                   bind:serviceProgramming
                   bind:numDays
                   bind:eventTags on:program/>